import React from 'react';
import './Componenst.css';
import CompanyModel from '../models/CompanyModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createCompany, showError } from '../ViewCreator';

function Company({ changeSearch, searchModel, setView, addNew = () => {}, isAdd = false }) {

    const personModel = new CompanyModel();


    const clearSubmit = () => {

    document.getElementById('orpo').value     = '';
    document.getElementById('activity').value     = '';
    document.getElementById('nameCompany').value     = '';
    personModel.infoCompany = ''
    personModel.orpo = ''
    personModel.activity = ''
    personModel.nameCompany = ''
    if (searchModel != undefined ) {
      searchModel.company.infoCompany = ''
      searchModel.company.orpo = ''
      searchModel.company.activity = ''
      searchModel.company.nameCompany = ''
    }
    }

    const addSubmit = () => {
        if (personModel.nameCompany == undefined || personModel.nameCompany == '') {
            showError('Назва не може бути пустою')
            return;
        }

        if (personModel.activity == undefined || personModel.activity == '') {
            showError('Діяльність не може бути пустою')
            return;
        }
          isUniq()
    }

    const isUniq = () => {
        var path = ip + '/api/company/search';
        personModel.searchModel = new SearchModel()
        var pp = new CompanyModel();
        pp.nameCompany = personModel.nameCompany
        pp.activity = personModel.activity
        
        var bd = encryptAes(JSON.stringify(pp))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
    
              if (result.data.length > 0) {
                Swal.fire({
                    title: 'Запис уже існує',
                    //text: "Оновити інформацію?",
                    icon: 'warning',
                    html:
                    'Запис з такими даними вже існує, Ви можете ' +
                    '<a href="/company?id='+result.data[0].id+'" style="color:#FFFFFF;"  target="_blank">переглянути запис</a>',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: 'ОК',
                      denyButtonText: 'Оновити',
                      background: '#2B2B2B',
                      color: '#FFF'
                    }).then((result) => {
                    })
                  sendSearch()
              } else {
                Swal.fire({
                  title: 'Ви дійсно бажаєте створити новий запис',
                  //text: "Оновити інформацію?",
                  icon: 'question',
                  html:
                  '',
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: 'Створити',
                  denyButtonText: 'Оновити',
    
                  background: '#2B2B2B',
                  color: '#FFF'
                }).then((result) => {
                  addNewCompany()
                  })
                
              }
            }
          })
      }

      const addNewCompany = () => {
        var path = ip + '/api/company/add';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
              
    
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
              if (isAdd) {
                addNew(result.data, 20003)
                clearSubmit()
              } else {
              window.open("/edit/company?id="+result.data, "_self")
              }
            }
          })
      }
    const sendCompanyFullScreen = (id) => {
        window.open("/company?id=" + id)
    }

    const sendCompany = (id) => {
        var path = ip + '/api/company/id';
       var bd = encryptAes(id)
           const requestOptions = {
             headers: {
               'Content-Type': 'Content-type: text/html; charset=win1251'
             },
             credentials: 'include',
             uri: path,
             encoding: 'latin1',
             body: bd,
             method: 'POST'
           };
           fetch(path, requestOptions)
           .then()
           .then(response => { return response.arrayBuffer() })
           .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                    

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []
                
                    var addr = result.data
                    
                    zz.push(createCompany(addr))
    
                    String.prototype.replaceAt = function(index, replacement) {
                        return this.substr(0, index) + replacement + this.substr(index + replacement.length);
                      }
                      var spr =  document.createElement('div');
                      spr.className = "spravka"
                      
                      spr.innerHTML = "<hr><p>"+addr.infoCompany.replace(/\r\n/g, "<p>"); 
                      zz.push(spr)

                    setView(zz)
                }
            })
    }


    const handleSubmit = (e) => {
        sendSearch();
        e.preventDefault();
    }

    const sendSearch = () => {
        var path = ip + '/api/company/search';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []

                    for (let index = 0; index < result.data.length; index++) {
                        var z = document.createElement('div'); // is a node
                        var pers = result.data[index]
                        var i = pers.id
                        z.className = "listItem"
                        z.innerHTML = "<p align=\"left\">"+pers.nameCompany + "<br>"+ pers.activity + "<br>" + pers.orpo;
                        z.style.display = "block";
                        const cl = i => () => {
                            sendCompany(i)
                        }
                        const dblcl = i => () => {
                            sendCompanyFullScreen(i)
                        }
                        //z.onclick = cl(pers.id)
                        z.ondblclick = dblcl(pers.id)
                        var per = new CompanyModel()
                        per.id = pers.id
                        z.value = per
                        zz.push(z);
                    }
                    changeSearch(zz)
                }
            })
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }
    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id)
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "List").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "List").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id).value = l[index]
                            document.getElementById(id + "List").innerHTML = "";

                            if(id=='nameCompany'){
                        
                                personModel.nameCompany = l[index]
                                
                              }
                              if(id=='activity'){
                                personModel.activity = l[index]

                              }
                              if(id=='orpo'){
                                personModel.orpo = l[index]

                              }

                        }
                        document.getElementById(id + "List").appendChild(z);

                    }
                }
            })








    }


        const namechange = () => {
        personModel.nameCompany = document.getElementById('nameCompany').value
        changedfield('nameCompany');
      }
    
      const activitychange = () => {
        personModel.activity = document.getElementById('activity').value
        changedfield('activity');
      }
    
      const orpochange = () => {
        personModel.orpo = document.getElementById('orpo').value
        changedfield('orpo');
      }


    const handleFocus = (event) => {
        closeAllHelp()
    };

    return (
        <div>
            <button id="clear-button-company" className="clear-button-right" onClick={clearSubmit}>Очистити
            </button>
            <button id="add-button-company" className="add-button-right" onClick={addSubmit}>Додати
            </button>
            <form onSubmit={handleSubmit} className="form">
                <input id="input-button-company" className="input-button-right" type="submit" value="Пошук" />

               

                <div id="orpoDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="orpo" className="input-text" tabIndex="3" name="login" type="text" onChange={orpochange}  placeholder="ОРПО" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="orpoList" className="list" />
          </div>
          <div id="activityDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="activity" className="input-text" tabIndex="2" name="login" type="text" onChange={activitychange}  placeholder="Діяльність" autoComplete="off"  onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="activityList" className="list" />
          </div>
          <div id="nameCompanyDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="nameCompany" className="input-text" tabIndex="1" name="login" type="text" onChange={namechange}  placeholder="Назва" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="nameCompanyList" className="list" />
          </div>
            </form>
        </div>
    );
}

export default Company;